import { LoadBannersUsecase, LoadBannersUsecaseImp } from 'domain/usecases/load-banners-usecase';
import { makeLoadBannersFirestoreRepository } from '../repositories/firebase/load-banners-firestore-repository-factory';

export const makeLoadBannersUsecase = (): LoadBannersUsecase => {
  return new LoadBannersUsecaseImp(makeLoadBannersFirestoreRepository());
};
